import script from "./ProjectsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectsSection.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectsSection.vue?vue&type=style&index=0&id=9dc14456&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dc14456"]])

export default __exports__